<app-collapsible-section
  title="Schedule"
  [isExpanded]="isExpanded"
  [isCompleted]="isCompleted"
  [showDoneButton]="true"
  (toggle)="onScheduleToggle($event)"
  (done)="onScheduleDone()"
>
  <ng-template #sectionContent>
    <div class="schedule-form">
      <!-- Start Date & Time -->
      <div class="form-group">
        <label class="form-label">Start Date & Time</label>
        <div class="date-picker-trigger" (click)="openStartDatePicker()">
          <span class="date-display" *ngIf="startDateTime">
            {{
              startDateTime ? (startDateTime | date: 'MMM d y, h:mm a') : 'Select start date & time'
            }}
          </span>
          <span class="date-display" style="opacity: 0.5" *ngIf="!startDateTime">
            {{
              startDateTime ? (startDateTime | date: 'MMM d y, h:mm a') : 'Select start date & time'
            }}
          </span>
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.39844 7.42812C1.39844 4.78826 1.39844 3.46833 2.21854 2.64823C3.03864 1.82812 4.35857 1.82812 6.99844 1.82812C9.6383 1.82812 10.9582 1.82812 11.7783 2.64823C12.5984 3.46833 12.5984 4.78826 12.5984 7.42812C12.5984 10.068 12.5984 11.3879 11.7783 12.208C10.9582 13.0281 9.6383 13.0281 6.99844 13.0281C4.35857 13.0281 3.03864 13.0281 2.21854 12.208C1.39844 11.3879 1.39844 10.068 1.39844 7.42812Z"
              stroke="#6B7280"
              stroke-width="1.5"
            />
            <path
              d="M9.33594 0.818359V3.15169"
              stroke="#6B7280"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M4.66406 0.818359V3.15169"
              stroke="#6B7280"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M1.75 5.13281H12.25"
              stroke="#6B7280"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div>

      <!-- Recurring Frequency -->
      <div class="form-group">
        <label class="form-label">Recurring Frequency</label>
        <div class="frequency-options">
          <div class="frequency-row">
            <label
              class="frequency-option"
              [class.selected]="selectedFrequency === 'no_recurrence'"
            >
              <input
                type="radio"
                name="frequency"
                value="no_recurrence"
                [(ngModel)]="selectedFrequency"
                (ngModelChange)="onFormChange()"
                class="frequency-radio"
              />
              <span class="frequency-text">No recurrence</span>
            </label>
            <label class="frequency-option" [class.selected]="selectedFrequency === 'daily'">
              <input
                type="radio"
                name="frequency"
                value="daily"
                [(ngModel)]="selectedFrequency"
                (ngModelChange)="onFormChange()"
                class="frequency-radio"
              />
              <span class="frequency-text">Daily</span>
            </label>
          </div>
          <div class="frequency-row">
            <label class="frequency-option" [class.selected]="selectedFrequency === 'weekly'">
              <input
                type="radio"
                name="frequency"
                value="weekly"
                [(ngModel)]="selectedFrequency"
                (ngModelChange)="onFormChange()"
                class="frequency-radio"
              />
              <span class="frequency-text">Weekly</span>
            </label>
            <label class="frequency-option" [class.selected]="selectedFrequency === 'monthly'">
              <input
                type="radio"
                name="frequency"
                value="monthly"
                [(ngModel)]="selectedFrequency"
                (ngModelChange)="onFormChange()"
                class="frequency-radio"
              />
              <span class="frequency-text">Monthly</span>
            </label>
          </div>
        </div>
      </div>

      <!-- End Date & Time -->
      <div class="form-group" *ngIf="isRecurringFrequencySelected()">
        <label class="form-label">End Date & Time <span class="required">*</span></label>
        <div class="date-picker-trigger" (click)="openEndDatePicker()">
          <span class="date-display" *ngIf="endDateTime">
            {{ endDateTime ? (endDateTime | date: 'MMM d y, h:mm a') : 'Select end date & time' }}
          </span>
          <span class="date-display" style="opacity: 0.5" *ngIf="!endDateTime">
            {{ endDateTime ? (endDateTime | date: 'MMM d y, h:mm a') : 'Select end date & time' }}
          </span>

          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.39844 7.42812C1.39844 4.78826 1.39844 3.46833 2.21854 2.64823C3.03864 1.82812 4.35857 1.82812 6.99844 1.82812C9.6383 1.82812 10.9582 1.82812 11.7783 2.64823C12.5984 3.46833 12.5984 4.78826 12.5984 7.42812C12.5984 10.068 12.5984 11.3879 11.7783 12.208C10.9582 13.0281 9.6383 13.0281 6.99844 13.0281C4.35857 13.0281 3.03864 13.0281 2.21854 12.208C1.39844 11.3879 1.39844 10.068 1.39844 7.42812Z"
              stroke="#6B7280"
              stroke-width="1.5"
            />
            <path
              d="M9.33594 0.818359V3.15169"
              stroke="#6B7280"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M4.66406 0.818359V3.15169"
              stroke="#6B7280"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M1.75 5.13281H12.25"
              stroke="#6B7280"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div>

      <!-- Finish Button -->
      <div class="button-container">
        <button
          class="btn btn-primary btn-medium"
          (click)="onFinish()"
          [disabled]="!isAllSectionsCompleted || !canFinish()"
          [matTooltip]="finishButtonTooltip"
          [matTooltipDisabled]="isAllSectionsCompleted && canFinish()"
          matTooltipPosition="below"
        >
          <span class="button-text">Finish</span>
          <svg
            width="14"
            height="10"
            viewBox="0 0 14 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.2998 1.46581L5.23417 8.53416L1.69728 4.99999"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
  </ng-template>
</app-collapsible-section>

<!-- Campaign Date Picker Modals -->
<app-campaign-date-picker
  [isVisible]="showStartDatePicker"
  [selectedDateTime]="startDateTime"
  [minDate]="getCurrentDateTime()"
  [title]="'Start date & time'"
  (closeModal)="closeStartDatePicker()"
  (dateTimeSelected)="onStartDateSelected($event)"
>
</app-campaign-date-picker>

<app-campaign-date-picker
  [isVisible]="showEndDatePicker"
  [selectedDateTime]="endDateTime"
  [minDate]="getEndDateMinDate()"
  [title]="'End date & time'"
  (closeModal)="closeEndDatePicker()"
  (dateTimeSelected)="onEndDateSelected($event)"
>
</app-campaign-date-picker>
